import components from "./components.js";
import pages from "./pages/index.js";
import wlps from "./wlps.js";

export default {
  apply: "Appliquer",
  asOf: (ctx) => `au ${ctx.named("date")}`,
  cancel: "Annuler",
  contactUs: "Contactez-nous",
  edit: "Editer",
  error: "Erreur",
  from: "Du",
  ok: "Ok",
  loading: "Chargement...",
  logIn: "S'identifier",
  logOut: "Se déconnecter",
  no: "Non",
  others: "Autres",
  register: "S'inscrire",
  save: "Sauvegarder",
  saving: "Sauvegarde...",
  serverError:
    "Une erreur s'est produite dans notre serveur. Un rapport a été envoyé à notre équipe et nous allons y remédier dès que possible. N'hésitez pas à nous contacter si le problème persiste.",
  success: "Succès",
  to: "Au",
  warning: "Avertissement",
  yes: "Oui",
  investorProfileTypes: {
    institutional: "Investisseur institutionnel",
    professional: "Investisseur professionnel",
    retail: "Investisseur particulier",
  },
  layouts: {
    main: {
      admin: {
        listUsers: "Liste des utilisateurs",
        platformSettings: "Paramètres de la plateforme",
        products: "Produits",
        sectionName: "Admin",
        holdingDataAdjustments: {
          name: "Ajustements des données de positions",
          categorise: {
            name: "Catégoriser",
          },
          translate: {
            name: "Traduire",
          },
          override: {
            name: "Remplacer",
          },
        },
        operations: {
          name: "Opérations",
          bulkPriceDataUpdate: {
            name: "Mise à jour des données de prix",
          },
          generateReports: {
            name: "Générer des rapports",
          },
          bulkComponentsUpdate: {
            name: "Importer des composants génériques",
          },
          exports: {
            name: "Exports",
          },
        },
      },
      help: {
        contact: "Contact",
        faq: "FAQ",
        knowledgeBase: "Base de connaissances",
        sectionName: "Aide",
      },
      investmentProposal: {
        sectionName: "Proposition d'investissement",
        reportGenerationSubSectionName: "Génération de rapport",
        weightOptimizationSubSectionName: "Optimisation des pondérations",
      },
      products: {
        analysis: "Analyse",
        documents: "Documents",
        factsheet: "Factsheet",
        overview: "Aperçu",
        sectionName: "Produits",
        useCase: "Cas d'utilisation",
      },
    },
    fullPage: {
      backHome: "Retour à l'accueil",
    },
    navbar: {
      openInVue3: "Passer à la nouvelle version",
    },
    profileDropDown: {
      settings: "Paramètres",
      dialog: {
        adminAsRegularOnMobile: {
          text: "Les fonctions administratives ne sont pas accessibles sur les appareils mobiles. Pour profiter pleinement de la plateforme, veuillez utiliser un ordinateur de bureau. Les fonctions administratives désactivées comprennent (sans s'y limiter) : l'édition d'éléments dans la vue d'ensemble, l'édition de la fiche d'information, le téléchargement ou la suppression de documents et l'accès à la section d'administration.",
          title: "Ordinateur de bureau nécessaire pour les fonctions d'administration",
        },
      },
    },
    theFooter: {
      allRightReserved: "Tous droits réservés",
      copyright: "Copyright",
      ombudsman: "Médiateur",
      privacyPolicy: "Politique de confidentialité",
      termsOfUse: "Conditions d'utilisation",
    },
    verticalNavMenu: {
      closeMenuTextWhenEmbedded: "Fermer",
      errorLoading: "Erreur lors du chargement du menu",
      openMenuTextWhenEmbedded: "Afficher tous les fonds",
    },
    verticalNavMenuGroup: {
      search: "Recherche",
      showMore: "Afficher plus",
    },
  },
  perfStats: {
    alpha: "Alpha",
    annualizedReturn: "Rendement annualisé",
    annualizedVolatility: "Volatilité annualisée",
    annualizedVolatilityDaily: "Volatilité annualisée (journalière)",
    averageMonthlyReturns: "Rendement mensuel moyen",
    averageNegativeMonthlyReturns: "Moyenne des rendements mensuels négatifs",
    averagePositiveMonthlyReturns: "Moyenne des rendements mensuels positifs",
    beta: "Beta",
    calmarRatio: "Ratio de Calmar",
    painRatio: "Ratio de douleur",
    painIndex: "Indice de douleur",
    correlation: "Corrélation",
    cumulativeReturn: "Rendement cumulé",
    informationRatio: "Ratio d'information résiduelle",
    activeInformationRatio: "Ratio d'information active",
    kurtosis: "Kurtosis",
    m2RiskAdjustedPerfMonthly: "Mesure M2",
    maxDaysUnderwater: "Nombre max. de jours en perte",
    maxMonthsUnderwater: "Nombre max. de mois en perte",
    maxConsecutiveNegativeMonthlyReturns: "Maximum de rendements mensuels négatifs consécutifs",
    maxConsecutivePositiveMonthlyReturns: "Maximum de rendements mensuels positifs consécutifs",
    maxNegativeMonthlyReturn: "Rendement mensuel négatif maximal",
    maxPositiveMonthlyReturn: "Rendement mensuel positif maximal",
    maximumDrawdown: "Drawdown maximal",
    maximum: "Maximum",
    minimum: "Minimum",
    omegaRatio: "Ratio Omega",
    ratioOfNegativeMonthlyReturns: "Ratio des rendements mensuels négatifs",
    ratioOfPositiveMonthlyReturns: "Ratio des rendements mensuels positifs",
    returnToVolatilityRatio: "Ratio rendement/volatilité",
    sharpeRatio: "Ratio de sharpe",
    skewness: "Coefficient d'asymétrie",
    sortinoRatio: "Ratio de Sortino",
    trackingError: "Ecart de suivi",
    treynorRatio: "Ratio de Treynor",
    valueAtRiskOnePercentOneMonth: "Valeur à Risque (VaR) 1% sur 1 mois",
    valueAtRiskFivePercentOneMonth: "Valeur à Risque (VaR) 5% sur 1 mois",
    valueAtRiskOnePercentTwoWeeks: "Valeur à Risque (VaR) 1% sur 2 semaines",
    valueAtRiskFivePercentTwoWeeks: "Valeur à Risque (VaR) 5% sur 2 semaines",
    valueAtRiskOnePercentOneDay: "Valeur à Risque (VaR) 1% sur 1 jour",
    valueAtRiskFivePercentOneDay: "Valeur à Risque (VaR) 5% sur 1 jour",
  },
  validations: {
    afterDate: (ctx) =>
      ctx.named("nDaysApart") == 0
        ? `La date doit être postérieure à ${ctx.named("minDate")} (incluse)`
        : `La date doit être au moins ${ctx.named(
            "nDaysApart"
          )} jours après ${ctx.named("minDate")}`,
    beforeDate: (ctx) =>
      ctx.named("nDaysApart") == 0
        ? `La date doit être antérieure à ${ctx.named("maxDate")} (incluse)`
        : `La date doit être au moins ${ctx.named(
            "nDaysApart"
          )} jours avant ${ctx.named("maxDate")}`,
    confirmed: "Le champ ne correspond pas au champ précédent.",
    dateFormat: "La date doit être au format AAAA-MM-JJ.",
    email: "L'email n'est pas valide.",
    maxFileSize: (ctx) =>
      `Le fichier est plus grand que la taille maximale autorisée (${ctx.named(
        "maxSizeMegabytes"
      )} Mo).`,
    maxChar: (ctx) => `Le champ ne peut pas comporter plus de ${ctx.named("length")} caractères.`,
    minChar: (ctx) => `Le champ doit contenir au moins ${ctx.named("length")} caractères.`,
    minValue: (ctx) => `La valeur doit être supérieure ou égale à ${ctx.named("min")}.`,
    phoneNumber: "Ce champ n'est pas un numéro de téléphone valide.",
    required: "Ce champ est requis.",
    roleFormat: 'Le nom du rôle ne peut pas contenir le caractère ":".',
    forbiddenRoleName: "Ce nom de rôle est réservé.",
    sum: (ctx) =>
      `La somme attendue est ${ctx.named(
        "expectedValue"
      )} (actuelle: ${ctx.named("currentValue")}).`,
  },
  wlps,
  pages,
  components,
};
